import React from 'react';
import PropTypes from 'prop-types';

const TurnRightIcon = ({
  
style = {},
  fill = 'grey',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 150 96',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M47.5327 57.5227L47.7199 34.7715L78.0197 65.3199L47.2213 95.3656L47.4104 72.3809C19.6415 66.8849 0 53.3393 0 37.5C0 16.7891 33.5791 0 75 0C116.421 0 150 16.7891 150 37.5C150 53.4512 130.08 67.0762 102 72.4961V57.6113C122.715 53.7266 137 45.5078 137 36C137 22.7461 109.241 12 75 12C40.7588 12 13 22.7461 13 36C13 45.4361 27.0706 53.6026 47.5327 57.5227Z" />
      </svg>
);

TurnRightIcon.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string,
};

export default TurnRightIcon;
